// If anyone feels lost here....
// https://docs.google.com/spreadsheets/d/1flrcDbTKD34OKRyz-tsuFpAYzqlxN0KiQBmTEJxEoyw/edit?gid=0#gid=0

// Migration build: product URLs repointed to *.migration.penrosesystems.com (dots->dashes).
// how2ai / smartdr are third-party VAS apps with no migration host, so they stay on prod.
export const productConfigUrl = new Map([
    [251124001, 'https://ng-mtn-stoptheclock-app.migration.penrosesystems.com'],
    [251124002, 'https://ng-mtn-quizhead2head-app.migration.penrosesystems.com'],
    [251202001, 'https://izeplaytv-fantasydribble-com.migration.penrosesystems.com'],
    [251202002, 'https://ng-airtel-stoptheclock-app.migration.penrosesystems.com/login'],
    [251202003, 'https://ng-airtel-quizhead2head-app.migration.penrosesystems.com/welcome'],
    [251208001, 'https://ng-airtel-blg-gg.migration.penrosesystems.com/guest'],
    [251208002, 'https://izeplaytv-fantasydribble-com.migration.penrosesystems.com'],
    [251208005, 'https://izeplay-fantasydribble-com.migration.penrosesystems.com'],
    [251211001, 'https://ng-mtn-blg-gg.migration.penrosesystems.com'],
    [251211002, 'https://izeplay-fantasydribble-com.migration.penrosesystems.com'],
    [251212001, 'https://mtn.how2ai.co'],
    [251212002, 'https://mtn.smartdr.org'],
])

export const productIdConfig = new Map([
    [251124001, 65],
    [251124002, 64],
    [251202001, 69],
    [251202002, 51],
    [251202003, 52],
    [251208001, 50],
    [251208002, 69],
    [251208005, 70],
    [251211001, 66],
    [251211002, 70],
    [251212001, 84],
    [251212002, 83],
])

export const serviceIdConfig = new Map([
    [251124001, 234102200008305],
    [251124002, 234102200008310],
    [251202001, 40195],
    [251202002, 40155],
    [251202003, 40165],
    [251208001, 40145],
    [251208002, 40195],
    [251208005, 234102200008303],
    [251211001, 234102200008312],
    [251211002, 234102200008303],
    [251212001, 23410220000050819],
    [251212002, 23410220000050821],
])
